<template>
    <div class="main-container">
        <img class="logo" src="../../assets/Drifter/icon.png" alt="Logo"/>
        <span class="title">Drifter AR</span>
        <span class="desc">Drift through the space and avoid flying objects from damaging your spaceship!</span>
        <a href="https://apps.apple.com/app/id1477133755"><img src="../../assets/Drifter/appstore-black.svg" style="margin-top:20px;margin-bottom:20px"></a>
        <span style="font-size:9pt"><router-link to="/drifter/privacy">Privacy Policy</router-link></span>
    </div>
</template>

<style scoped>
    .main-container{
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height:100%;
        width:100%;
    }

    .logo{
        max-width:320px;
        width:80%;
        border-radius: 50px;
    }

    .title{
        font-style: italic;
        font-size:20pt;
        font-weight: bold;
    }
</style>

<script>

    export default {
        name: "Drifter"
    }

</script>